import { render, staticRenderFns } from "./priceRecord.vue?vue&type=template&id=20662248&scoped=true"
import script from "./priceRecord.vue?vue&type=script&lang=js"
export * from "./priceRecord.vue?vue&type=script&lang=js"
import style0 from "./priceRecord.vue?vue&type=style&index=0&id=20662248&prod&lang=css"
import style1 from "./priceRecord.vue?vue&type=style&index=1&id=20662248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20662248",
  null
  
)

export default component.exports